import { createAsyncActions } from '~/utils/store';

export const SHOW = '@@DRAWER_SOCIAL_SELLING/SHOW';
export const CLOSE = '@@DRAWER_SOCIAL_SELLING/CLOSE';
export const SET_SELECTED_MONTH = '@@SOCIAL_SELLING/SET_SELECTED_MONTH';

export const CREATE = createAsyncActions('@@DRAWER_SOCIAL_SELLING/CREATE');
export const BATCH = createAsyncActions('@@DRAWER_SOCIAL_SELLING/BATCH');
export const SAVE = createAsyncActions('@@DRAWER_SOCIAL_SELLING/SAVE');
export const DELETE = createAsyncActions('@@DRAWER_SOCIAL_SELLING/DELETE');
export const BULK_DELETE = createAsyncActions('@@DRAWER_SOCIAL_SELLING/BULK_DELETE');

export const FETCHQTDD = createAsyncActions('@@SOCIAL_SELLING/FETCHQTDD');
export const MOVE = createAsyncActions('@@SOCIAL_SELLING/MOVE');
export const LOAD = createAsyncActions('@@SOCIAL_SELLING/LOAD');
export const LOAD_MORE_LEADS = createAsyncActions('@@SOCIAL_SELLING/LOAD_MORE_LEADS');
export const LOAD_CADENCE_SUMMARY = createAsyncActions('@@SOCIAL_SELLING/LOAD_CADENCE_SUMMARY');
export const LOAD_CADENCE_DETAILED_SUMMARY = createAsyncActions('@@SOCIAL_SELLING/LOAD_CADENCE_DETAILED_SUMMARY');
export const LOAD_SUMMARY_CARD_LEADS = createAsyncActions('@@SOCIAL_SELLING/LOAD_SUMMARY_CARD_LEADS');

export const show = (data = null) => ({
    type: SHOW,
    payload: {
        data
    }
});

export const close = () => ({
    type: CLOSE,
    payload: {}
});

export const create = (data) => ({
    type: CREATE.INIT,
    payload: {
        request:{
            method: 'post',
            url:'/leads_v2',
            data,
            showLoading: false
        }
      }
});

export const batch = (data) => ({
    type: BATCH.INIT,
    payload: {
        request:{
            method: 'post',
            url:'/leads_v2/batch',
            data,
            showLoading: false,
            suppressSuccessMessage: true
        }
      }
});

export const update = (id, data) => ({
    type: SAVE.INIT,
    payload: {
        request:{
            method: 'put',
            url:`/leads_v2/${id}`,
            data,
            showLoading: false
        }
    }
});

export const remove = (lead) => ({
    type: DELETE.INIT,
    payload: {
        request:{
            method: 'delete',
            url:`/leads_v2/${lead.id}`
        },
        lead
    }
});

export const loadLeads = ({ ...params }) => ({
    type: LOAD.INIT,
    payload: {
        request: {
            method: "GET",
            url: `/leads_v2?entity_type=socialSelling${params.date ? `&date=${params.date}` : ''}`,
            ...params,
            showLoading: false
        }
    }
});

export const loadMoreLeads = ({ columnId, currentCount, moreCount }) => ({
    type: LOAD_MORE_LEADS.INIT,
    payload: {
        request: {
            method: "GET",
            url: `/leads_v2/more?stage=${columnId}&current_count=${currentCount}&more_count=${moreCount}&entity_type=socialSelling`,
            columnId
        },
    },
})

export const fetchQtddByMonth = ({ date }) => ({
    type: FETCHQTDD.INIT,
    payload: {
        request:{
            method: 'get',
            url:`/leads_v2/qtdd/${date}?entity_type=socialSelling`
        }
    }
});

export const move = (props) => ({
    type: MOVE.INIT,
    payload: {
        request:{
            method: 'put',
            url:`/leads_v2/${props[4]}/move?entity_type=socialSelling`,
            data: {to: props[3].droppableId}
        },
    },
    props: props
});

export const setSelectedMonth = (month) => ({
    type: SET_SELECTED_MONTH,
    payload: {
        month
    }
});

export const bulkDelete = (leadIds) => ({
    type: BULK_DELETE.INIT,
    payload: {
        request:{
            method: 'delete',
            url:'/leads_v2/bulk-delete',
            data: { ids: leadIds },
            showLoading: false
        },
        leadIds
    }
});

export const updateColumnsForCadence = (cadenceData) => ({
    type: 'UPDATE_COLUMNS_FOR_CADENCE',
    payload: {
        cadenceData
    }
});

export const showSummaryDrawer = (summaryData) => ({
    type: 'SHOW_SUMMARY_DRAWER',
    payload: {
        summaryData,
        show: true
    }
});

export const closeSummaryDrawer = () => ({
    type: 'CLOSE_SUMMARY_DRAWER',
    payload: {
        summaryData: null,
        leads: [],
        show: false
    }
});

export const loadSummaryCardLeads = (cardType, cadenceName, date) => ({
    type: LOAD_SUMMARY_CARD_LEADS.INIT,
    payload: {
        request: {
            method: 'GET',
            url: '/leads_v2/summary-card-leads?entity_type=socialSelling' +
                '&card_type=' + encodeURIComponent(cardType) +
                (cadenceName ? '&cadence_name=' + encodeURIComponent(cadenceName) : '') +
                (date ? '&date=' + date : ''),
            showLoading: false
        }
    }
});

export const loadCadenceSummary = () => ({
    type: LOAD_CADENCE_SUMMARY.INIT,
    payload: {
        request: {
            method: 'GET',
            url: '/leads_v2/cadence-summary?entity_type=socialSelling',
            showLoading: false
        }
    }
});

export const loadCadenceDetailedSummary = (cadenceName, date) => ({
    type: LOAD_CADENCE_DETAILED_SUMMARY.INIT,
    payload: {
        request: {
            method: 'GET',
            url: '/leads_v2/cadence-detailed-summary?entity_type=socialSelling' +
                (cadenceName ? '&cadence_name=' + encodeURIComponent(cadenceName) : '') +
                (date ? '&date=' + date : ''),
            showLoading: false
        }
    }
});

export const checkInstagramExists = (usernames) => ({
    type: 'CHECK_INSTAGRAM_EXISTS',
    payload: {
        request: {
            method: 'POST',
            url: '/leads_v2/check-instagram-exists',
            data: {
                usernames: usernames,
                entity_type: 'socialSelling'
            },
            showLoading: false
        }
    }
});